export { default } from "./ClaimDealModal";
